const FC_RESPONSE_MARKER_PATTERN = /<\|FCResponse(?:Begin|End)\|>/g;
const TRAILING_SPECIAL_MARKER_PREFIX_PATTERN = /<\|[A-Za-z0-9_]*$/;

export const stripModelProtocolMarkers = (text = '') => {
  return `${text || ''}`
    .replace(FC_RESPONSE_MARKER_PATTERN, '')
    .replace(TRAILING_SPECIAL_MARKER_PREFIX_PATTERN, '');
};
